import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withKeys as _withKeys, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/username.png'
import _imports_1 from '@/assets/img/password.png'
import _imports_2 from '@/assets/img/refresh-1.svg'
import _imports_3 from '@/assets/img/changePad-1.svg'
import _imports_4 from '@/assets/img/loginout-1.svg'
import _imports_5 from '@/assets/img/icon-o-attention.svg'


const _withScopeId = n => (_pushScopeId("data-v-77560a1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-bg" }
const _hoisted_2 = { class: "language" }
const _hoisted_3 = {
  class: "el-dropdown-link",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = { class: "user-edit" }
const _hoisted_5 = { class: "autotoll" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "login"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"margin-left":"-7px","width":"20px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"margin-left":"-7px","width":"20px"}
}, null, -1))
const _hoisted_10 = { class: "rememberPassword" }
const _hoisted_11 = {
  key: 1,
  class: "userInfo"
}
const _hoisted_12 = { class: "userInfo-avtar" }
const _hoisted_13 = { class: "userInfo-introduction" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { style: {"margin-top":"16px","font-size":"16px","font-weight":"700","color":"#2D2D2D"} }
const _hoisted_17 = { class: "userInfo-hukou" }
const _hoisted_18 = { class: "userInfo-introduction-btn" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer",
  src: _imports_2,
  style: {"margin-right":"4px","transform":"translateY(1px)"}
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer",
  src: _imports_3,
  style: {"margin-right":"4px","transform":"translateY(1px)"}
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer",
  src: _imports_4,
  style: {"margin-right":"4px","transform":"translateY(1px)"}
}, null, -1))
const _hoisted_22 = { style: {"font-size":"16px","text-align":"center","color":"#5e6a71","font-weight":"400"} }
const _hoisted_23 = { class: "from" }
const _hoisted_24 = { style: {"padding-left":"18px"} }
const _hoisted_25 = { style: {"color":"#e35151","margin-bottom":"10px"} }
const _hoisted_26 = {
  class: "from",
  style: {"display":"flex"}
}
const _hoisted_27 = {
  class: "from",
  style: {"display":"flex"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"2px","transform":"translateY(2px)"},
  src: _imports_5
}, null, -1))
const _hoisted_29 = {
  class: "from",
  style: {"display":"flex"}
}

import { ref, computed, watch } from 'vue';
import { forgetPassword, updatePassword, sshLogin, login, logout, getAuthCode,advertClear } from '../loginApi';
import ChangePassword from './ChangePassword.vue';
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { passwordVerify } from '@/utils/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'User',
  emits: ['handleLogin', 'handleLogout'],
  setup(__props, { emit }) {

const { t } = useI18n();
const route = useRoute()
const router = useRouter();
const store = useStore();
const isToken = computed(() => store.getters.getoken);
const userInfo = computed(() => store.getters.getUserInfo);
const getLanguageValue = computed(() => store.getters.getLanguageValue);
const languageList = computed(() => store.state.language);
const simulateToken = computed(() => store.state.simulateToken);
const windowhost = ref(process.env.VUE_APP_GLOB_IMG_URL);


const autotolLogo = new URL('@/assets/img/Autotoll_LOGO.png', import.meta.url)
  .href;
// const avatar = new URL('@/assets/img/avatar.png', import.meta.url).href;
// const gaptchaImg = ref('');
// 初始化  获取验证码
// const init = () => {
//   getGaptcha('1').then((res) => {
//     gaptchaImg.value = window.URL.createObjectURL(res);
//   });
// };
// init();
const getAccount = () => {
  let text = t('login.fleetName')
  if (userInfo.value.userType == 'admin' || userInfo.value.userType == 'dev' || userInfo.value.userType == 'cs_leader' || userInfo.value.userType == 'cs') text = t('login.accountName')
  if (userInfo.value.userType == 'customer') text = t('login.customerName')
  if (userInfo.value.userType == 'normal') text = t('login.companyName')
  return text
}
const fromList = [
  { label: t('login.oldPassword'), value: 'oldPassword', type: 'password' },
  { label: t('login.newPassword'), value: 'newPassword', type: 'password', maxlength: 20, tipLabel: t('login.passwordStrengthTip') },
  {
    label: t('login.confirmPassword'),
    value: 'confirmPassword',
    maxlength: 20,
    type: 'password',
  },
  { label: t('login.account'), value: 'account', style: { width: getLanguageValue.value == 'en' ? '120px' : '80px' } },
  { label: t('login.email'), value: 'email',placeholder:t('login.pleaseEmail'), style: { width: getLanguageValue.value == 'en' ? '120px' : '80px' } },
];
const changePassword = ref({
  visible: false,
  title: t('login.forgotPassword'),
  type: 1,
  loading: false,
  outLoading: false,
  list: [
    {
      label: '',
      value: '',
    },
  ],
});

const loading = ref(false);

const user = ref({
  account: '',
  password: '',
});

// const checked1 = ref(false);
// 切换语言
const handleSwitchLang = (item: string) => {
  store.dispatch('swtichLang', item);
  // 刷新页面
  router.go(0);
};

const polarModalOpen = ref(false)
const polarForm = ref({
  account: '',
  password: '',
  configPassword: '',
})
if (store.state.polarFirstLoginForm && store.state.polarFirstLoginForm.account) {
  user.value.account = store.state.polarFirstLoginForm.account
}
if (store.state.polarFirstLogin) {
  polarModalOpen.value = true
  store.state.polarFirstLogin = false
  polarForm.value.account = store.state.polarFirstLoginForm.account
}
// 蓝色平台跳转登录
const handePolarLogin = () => {
  if (loading.value) return;
  const info = store.state.polarFirstLoginForm
  if (!polarForm.value.account) return ElMessage.error(t('login.pleaseUserName'));
  if (!polarForm.value.password) return ElMessage.error(t('login.pleasePassword'));
  if (passwordVerify(polarForm.value.password)) return ElMessage.error(passwordVerify(polarForm.value.password))
  if (polarForm.value.password !== polarForm.value.configPassword) return ElMessage.error(t('login.passwordiffent'));
  loading.value = true;
  sshLogin({ account: info.account, sshToken: info.token, newPsw: polarForm.value.password, timeStamp: new Date() }).then(res => {
    localStorage.setItem('singlelogin-userToken', res.data.token);
    localStorage.setItem('singlelogin-useRsaToken', res.data.rsaToken);
    localStorage.setItem('singlelogin-existMenu', res.data.existMenu);
    localStorage.setItem('singlelogin-firstTimeLogin', res.data.firstTimeLogin);
    store.dispatch('setUserToken', res.data);
    if (res.data.firstTimeLogin) {
      showClose.value = false
      handlePassword(2)
    }
    emit('handleLogin');
    loading.value = false;
    polarModalOpen.value = false
    // 登陸成功清除值 
    handeLogin(2);
  }).catch(() => {
    loading.value = false;
  })
};

// 登陆
const showClose = ref(true)
const handeLogin = (num: number) => {
  if (loading.value) return;
  // 重置
  if (num === 2) {
    user.value.account = '';
    user.value.password = '';
  } else {
    if (!user.value.account) return ElMessage.error(t('login.pleaseUserName'));
    if (!user.value.password) return ElMessage.error(t('login.pleasePassword'));
    loading.value = true;
    login(user.value)
      .then((res) => {
        // const token = res.data;
        localStorage.setItem('singlelogin-userToken', res.data.token);
        localStorage.setItem('singlelogin-useRsaToken', res.data.rsaToken);
        localStorage.setItem('singlelogin-existMenu', res.data.existMenu);
        localStorage.setItem('singlelogin-firstTimeLogin', res.data.firstTimeLogin);
        store.dispatch('setUserToken', res.data);
        if (res.data.firstTimeLogin) {
          showClose.value = false
          handlePassword(2)
        }
        emit('handleLogin');
        loading.value = false;
        // 登陸成功清除值
        handeLogin(2);
      })
      .catch((res) => {
        // if (res.resultCode === 400) {
        //   init();
        // }
        loading.value = false;
      });
  }
};

// 清除缓存  刷新页面
const handleRefresh = () => {
  advertClear().then(() => {
    window.location.reload()
  })
}

// 登出
const handleLogout = () => {
  changePassword.value.outLoading = true
  logout().then(() => {
    changePassword.value.outLoading = false
    store.dispatch('removerToken', '');
    emit('handleLogout');
  }).catch(() => {
    changePassword.value.outLoading = false
  });
};

const authItem = ref({
  authCode: '',
  authVisible: false
})
// 获取授权码 
// const handleAuthCode = () => {
//   authItem.value.authVisible = true
//   authItem.value.authCode = ''
//   getAuthCode({}).then(res => {
//     authItem.value.authCode = res.data
//   })
// }
// 复制
const handleCopy = () => {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard 向剪贴板写文本
    ElMessage.success(t('login.copySuccess'))
    return navigator.clipboard.writeText(authItem.value.authCode)
  } else {
    // 创建text area
    const textArea = document.createElement('textarea')
    textArea.value = authItem.value.authCode
    // 使text area不在viewport，同时设置不可见
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    ElMessage.success(t('login.copySuccess'))
    return new Promise((res, rej) => {
      // 执行复制命令并移除文本框
      document.execCommand('copy') ? res('') : rej()
      textArea.remove()
    })
  }
}


// 修改/忘記彈窗
const handlePassword = (num: number) => {
  if (num === 1) {
    changePassword.value.type = 1;
    changePassword.value.title = t('login.forgotPassword');
    changePassword.value.list = fromList.slice(3, fromList.length);
  } else {
    changePassword.value.type = 2;
    changePassword.value.title = t('login.editPassword');
    changePassword.value.list = fromList.slice(0, 3);
  }
  changePassword.value.visible = true;
};
const changePasswordbox = ref<any>(null);
const emailInfo = ref({
  forgetVisible: false,
  email: '',
});
// 修改/忘記密碼
const handleUpPassword = (item: any) => {
  if (changePassword.value.type === 2) {
    if (!item.oldPassword) return ElMessage.error(t('login.input') + t('login.oldPassword').toLowerCase());
    if (!item.newPassword) return ElMessage.error(t('login.input') + t('login.newPassword').toLowerCase());
    if (!item.confirmPassword) return ElMessage.error(t('login.input') + t('login.confirmPassword').toLowerCase());
    if (passwordVerify(item.newPassword)) return ElMessage.error(passwordVerify(item.newPassword))
    if (item.confirmPassword !== item.newPassword) return ElMessage.error(t('login.passwordiffent'));
    changePassword.value.loading = true;
    updatePassword(item)
      .then(() => {
        changePassword.value.loading = false;
        changePassword.value.visible = false;
        store.state.firstTimeLogin = false;
        localStorage.setItem('singlelogin-firstTimeLogin', 'false');
      })
      .catch((res) => {
        changePassword.value.loading = false;
        if (res.resultCode === 400) {
          changePasswordbox.value.init();
        }
      });
  } else {
    if (!item.account)
      return ElMessage.error(
        t('login.input') + t('login.account').toLowerCase()
      );
    if (!item.email)
      return ElMessage.error(t('login.input') + t('login.email').toLowerCase());
    changePassword.value.loading = true;

    forgetPassword(item)
      .then(() => {
        changePassword.value.loading = false;
        changePassword.value.visible = false;
        emailInfo.value.forgetVisible = true;
        emailInfo.value.email = item.email;
      })
      .catch((res) => {
        changePassword.value.loading = false;
        if (res.resultCode === 400) {
          changePasswordbox.value.init();
        }
      });
  }
};
// 监听是否第一次登录
const firstTimeLogin = computed(() => (store.state.firstTimeLogin));
watch(
  firstTimeLogin,
  (newData) => {
    if (newData && isToken) {
      handlePassword(2)
      showClose.value = false
    } else {
      changePassword.value.visible = false
    }
  },{ immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  onClick: ($event: any) => (handleSwitchLang(item.value)),
                  key: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(languageList.value.find((item) => item.value == getLanguageValue.value).label) + " ", 1),
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_component_arrow_down)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "user-opacity",
        style: _normalizeStyle({ padding: isToken.value ? '0 24px' : '0 40px' })
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: isToken.value ? userInfo.value && userInfo.value.tenantLogoUrl || '' : _unref(autotolLogo),
            style: {"max-width":"320px","max-height":"120px"},
            alt: ""
          }, null, 8, _hoisted_6)
        ]),
        (!isToken.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_input, {
                modelValue: user.value.account,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.account) = $event)),
                class: "w-50 m-2 inputbox",
                size: "large",
                placeholder: _ctx.$t('login.pleaseUserName'),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (handeLogin(1)), ["enter"]))
              }, {
                prefix: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_el_input, {
                modelValue: user.value.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password) = $event)),
                type: "password",
                class: "w-50 m-2 pads inputbox",
                size: "large",
                "show-password": "",
                placeholder: _ctx.$t('login.pleasePassword'),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (handeLogin(1)), ["enter"]))
              }, {
                prefix: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: "forgot pointer",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showClose.value = true,handlePassword(1)))
                }, _toDisplayString(_ctx.$t('login.forgotPassword')), 1)
              ]),
              _createElementVNode("div", {
                class: "btn land pointer",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (handeLogin(1)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('login.login')) + " ", 1),
                (loading.value)
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      class: "el-icon is-loading",
                      style: {"margin-left":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Loading)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "btn reset pointer",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handeLogin(2)))
              }, _toDisplayString(_ctx.$t('login.reset')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_avatar, {
                  class: "userInfo-avtar-bg",
                  size: 120,
                  src: (userInfo.value && userInfo.value.avatarUrl ? userInfo.value.avatarUrl : '')
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "userInfo-nickName",
                    title: userInfo.value && userInfo.value.nickName || ''
                  }, _toDisplayString(userInfo.value && userInfo.value.nickName || ''), 9, _hoisted_15),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(getAccount()), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(userInfo.value.tenantName), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (userInfo.value.userType == 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "userCommon_btn",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (handleRefresh()))
                      }, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('login.refresh')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "userCommon_btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (showClose.value = true,handlePassword(2)))
                  }, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('login.editPassword')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "userCommon_btn",
                    onClick: handleLogout
                  }, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(simulateToken.value?_ctx.$t('login.simulateLogout'):_ctx.$t('login.logout1')), 1)
                  ])
                ])
              ])
            ]))
      ], 4)
    ]),
    _createVNode(ChangePassword, {
      ref_key: "changePasswordbox",
      ref: changePasswordbox,
      visible: changePassword.value.visible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((changePassword.value.visible) = $event)),
      "from-list": changePassword.value.list,
      title: changePassword.value.title,
      onHandleSave: handleUpPassword,
      onHandleLoginOut: handleLogout,
      loading: changePassword.value.loading,
      showClose: showClose.value
    }, null, 8, ["visible", "from-list", "title", "loading", "showClose"]),
    _createVNode(_component_el_dialog, {
      modelValue: emailInfo.value.forgetVisible,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((emailInfo.value.forgetVisible) = $event)),
      title: _unref(t)('login.forgotPassword'),
      "align-center": true,
      width: "720px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('login.resetPassword')) + "：" + _toDisplayString(emailInfo.value.email) + "，" + _toDisplayString(_ctx.$t('login.loginPassword')), 1),
        _createElementVNode("div", {
          class: "enter",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (emailInfo.value.forgetVisible = false))
        }, _toDisplayString(_ctx.$t('login.confirm')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: authItem.value.authVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((authItem.value.authVisible) = $event)),
      title: _unref(t)('login.authCode'),
      "align-center": true,
      width: "720px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", {
            style: _normalizeStyle({ 'margin-right':getLanguageValue.value == 'en' ? '10px' : '' })
          }, _toDisplayString(_unref(t)('login.authCode')) + "：", 5),
          _createVNode(_component_el_input, {
            modelValue: authItem.value.authCode,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((authItem.value.authCode) = $event)),
            class: "w-50 m-2 inputbox",
            size: "large",
            placeholder: _unref(t)('login.authCode')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            size: "large",
            onClick: handleCopy
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('login.copyText')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('login.authTime')), 1),
        _createElementVNode("div", {
          class: "enter",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (authItem.value.authVisible = false))
        }, _toDisplayString(_ctx.$t('login.confirm')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: polarModalOpen.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((polarModalOpen).value = $event)),
      title: _ctx.$t('login.userLogin'),
      "align-center": true,
      width: "720px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('login.polarTip')), 1),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", {
            style: _normalizeStyle({width:getLanguageValue.value==='en'?'135px':'80px'})
          }, _toDisplayString(_ctx.$t('login.account')), 5),
          _createVNode(_component_el_input, {
            modelValue: polarForm.value.account,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((polarForm.value.account) = $event)),
            class: "w-50 m-2 inputbox",
            size: "large",
            placeholder: _ctx.$t('login.pleaseUserName'),
            onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (handePolarLogin()), ["enter"])),
            disabled: ""
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", {
            style: _normalizeStyle({width:getLanguageValue.value==='en'?'135px':'80px'})
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('login.newPassword')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              content: _ctx.$t('login.passwordStrengthTip'),
              placement: "top"
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }, 8, ["content"])
          ], 4),
          _createVNode(_component_el_input, {
            modelValue: polarForm.value.password,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((polarForm.value.password) = $event)),
            type: "password",
            class: "w-50 m-2 pads inputbox",
            size: "large",
            "show-password": "",
            placeholder: _ctx.$t('login.input')+_ctx.$t('login.newPassword'),
            onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (handePolarLogin()), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", {
            style: _normalizeStyle({width:getLanguageValue.value==='en'?'135px':'80px'})
          }, _toDisplayString(_ctx.$t('login.confirmPassword')), 5),
          _createVNode(_component_el_input, {
            modelValue: polarForm.value.configPassword,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((polarForm.value.configPassword) = $event)),
            type: "password",
            class: "w-50 m-2 pads inputbox",
            size: "large",
            "show-password": "",
            placeholder: _ctx.$t('login.againPassword'),
            onKeyup: _cache[20] || (_cache[20] = _withKeys(($event: any) => (handePolarLogin()), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", {
          class: "enter",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (handePolarLogin()))
        }, _toDisplayString(_ctx.$t('login.confirm')), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})